import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 10,
    margin: '20 10px 4 10px', // Margem: 0px em cima, 15px à direita, 0px embaixo, 25px à esquerda
},

  row: {
    flexDirection: 'row',  // Align the Text components horizontally
    textAlign: 'left'

  },
  leftSection: {
    textAlign: 'left',
  
  },
  title: {
    fontWeight: 'bold', // Negrito
    fontSize: '11px',
    color: '#00607f', // Cor baseada na imagem
    letterSpacing: '0.5px', // Espaçamento entre letras, ajustável
    textTransform: 'uppercase', // Para deixar tudo em maiúsculas
    fontFamily: "Roboto",
    
  },
  subTitle: {
    width: '94.8px',
    position: 'relative',
    fontSize: '8px', // Aumente o tamanho da fonte
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center', // Alinhe o texto verticalmente ao centro
    color: '#3c3c3c',
    marginRight: '-25px'

  },
  subTitles: {
    width: '94.8px',
    position: 'relative',
    fontSize: '8px', // Aumente o tamanho da fonte
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center', // Alinhe o texto verticalmente ao centro
    color: '#3c3c3c',
    marginRight: '-46px'

  },
  rightSection: {
    textAlign: 'right',
  },
  dateAndId: {
    fontSize: 8,
    color: "#00607F"
    
  },
  logo: { // 'logo' should be lowercase, not 'Logo'
    width: 200,        // Adjust the width to make the image smaller
    height: 30,    // Keep auto for aspect ratio
    objectFit: 'contain',  // Makes sure the image doesn't get distorted
  },
});

export default styles;
